import store from "../store/store";
const CPRHome = () =>
    import ("@/view/CPR/Home")
const CPRMenu = () =>
    import ('@/view/CPR/Menu')
const CPRSimulationCharacter = () =>
    import ('@/view/CPR/SimulationCharacter')
const CPRSimulation = () =>
    import ('@/view/CPR/Simulation')
const CPRSimulationSummary = () =>
    import ('@/view/CPR/SimulationSummary')
const CPRLessonSelect = () =>
    import ('@/view/CPR/LessonSelect')
const CPRLesson = () =>
    import ('@/view/CPR/LessonContent')
const CPRSummary = () =>
    import ('@/view/CPR/Summary')
const CPRVideo = () =>
    import ('@/view/CPR/Video')
const Question = () =>
    import ('@/view/CPR/Question')
const Preview = () =>
    import ('@/view/CPR/Preview')
const CPRSummaryFinal = () =>
    import ('@/view/CPR/SummaryFinal')
const CPRSummaryTable = () =>
    import ('@/view/CPR/SummaryTable')
const ifAuthenticated = (to, from, next) => {

    if (store.getters["auth/userStatus"]) {
        let courseCode = ""
        let enroll = store.getters["necessary/getUserEnrolledCourse"];

        next();

    } else {
        next('/homepage')
    }
}
export default [{
        path: '/CPR',
        name: 'CPR',
        component: CPRHome,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/CPRmenu',
        name: 'CPR-MENU',
        component: CPRMenu,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/CPRmenu',
        name: 'CPRMENU',
        component: CPRMenu,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/CPR/lifesaver',
        name: 'CPRlifesaver',
        component: CPRSimulationCharacter,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/CPR/simulation/:id',
        name: 'CPRSimulation',
        component: CPRSimulation,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/CPR/lifesaverSummary',
        name: 'CPRlifesaverSummary',
        component: CPRSimulationSummary,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/CPR/cprkids',
        name: 'CPRKids',
        component: CPRLessonSelect,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/CPR/lessonContent/:id',
        name: 'CPRcontent',
        component: CPRLesson,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/CPR/question',
        name: 'CPRQuestion',
        component: Question,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/CPR/preview/:id',
        name: 'CPRpreview',
        component: Preview,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/CPR/yourtruth',
        name: 'CPRSummaryFinal',
        component: CPRSummaryFinal,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/CPR/thetruthuntold',
        name: 'CPRVideo',
        component: CPRVideo,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/CPR/summary/:id',
        name: 'CPRSummary',
        component: CPRSummary,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/CPR/yourtruth/score',
        name: 'CPRSummaryTable',
        component: CPRSummaryTable,
        beforeEnter: ifAuthenticated

    }

]